import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPhone,
  faEnvelope,
  faMapMarkerAlt,
} from "@fortawesome/free-solid-svg-icons";
import { faFacebookF, faInstagram } from "@fortawesome/free-brands-svg-icons";
import logo from "../../assets/selfieSmail.png";
import "./FooterStyle.css";

const Footer = () => {
  const { t } = useTranslation();
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className="footer-section">
      <div className="footer-content">
        <div className="footer-grid">
          <div className="footer-logo">
            <img src={logo} alt="Dr Brand Logo" className="logo-img" />
            <p>{t("footer.ali_eldeeb_praise")}</p>
          </div>

          <div className="footer-links">
            <h3>{t("footer.links_title")}</h3>
            <ul>
              <li>
                <button
                  onClick={() => scrollToSection("home")}
                  className="footer-link-button"
                  type="button"
                >
                  {t("nav.home")}
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection("about")}
                  className="footer-link-button"
                  type="button"
                >
                  {t("nav.about")}
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection("services")}
                  className="footer-link-button"
                  type="button"
                >
                  {t("nav.services")}
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection("whyChooseUs")}
                  className="footer-link-button"
                  type="button"
                >
                  {t("nav.whyChooseUs")}
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection("GetInTouch")}
                  className="footer-link-button"
                  type="button"
                >
                  {t("nav.contact")}
                </button>
              </li>
            </ul>
          </div>

          <div className="footer-contact">
            <h3>{t("footer.contact_title")}</h3>
            <address className="contact-list">
              <li>
                <FontAwesomeIcon
                  icon={faMapMarkerAlt}
                  className="contact-icon"
                />
                <a
                  href="https://maps.app.goo.gl/bJStVzyBz6TAqQxQ7?g_st=ic"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="map-link"
                >
                  {t("footer.address")}
                </a>
              </li>
              <li>
                <FontAwesomeIcon icon={faPhone} className="contact-icon" />
                <a href={`tel:${t("footer.phone")}`} className="phone-link">
                  {t("footer.phone")}
                </a>
              </li>
              <li>
                <FontAwesomeIcon icon={faPhone} className="contact-icon" />
                <a href={`tel:${t("footer.phone2")}`} className="phone-link">
                  {t("footer.phone2")}
                </a>
              </li>
              <li>
                <FontAwesomeIcon icon={faEnvelope} className="contact-icon" />
                <a href={`mailto:${t("footer.email")}`} className="email-link">
                  {t("footer.email")}
                </a>
              </li>
            </address>
            <div className="footer-social-icons">
              <a
                href="https://www.facebook.com/share/15yURBUgLE/?mibextid=wwXIfr"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook Page"
              >
                <FontAwesomeIcon icon={faFacebookF} />
              </a>
              <a
                href="https://www.instagram.com/selfiesmile57?igsh=bXhqcDJqMTZndDh3"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram Page"
              >
                <FontAwesomeIcon icon={faInstagram} />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>
          © {new Date().getFullYear()} Selfie Smile. {t("footer.rights")}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
